export default "__VITE_ASSET___H4Qhn_n__"